/**
 * Parse WebSocket frames for INTERNAL_OPERATOR_REALTIME_V1 (single internal operator family).
 */

import {
  INTERNAL_OPERATOR_REALTIME_KIND,
  type InternalOperatorRealtimeEnvelopeV1,
} from '@core/types/internalOperatorRealtime';

function isValidInternalOperatorEnvelopeV1(
  envelope: unknown
): envelope is InternalOperatorRealtimeEnvelopeV1 {
  if (!envelope || typeof envelope !== 'object') return false;
  const e = envelope as Record<string, unknown>;
  if (e.kind !== INTERNAL_OPERATOR_REALTIME_KIND) return false;
  if (e.schemaVersion !== 1) return false;
  if (typeof e.meetingId !== 'string' || !e.meetingId.trim()) return false;
  if (!Array.isArray(e.items)) return false;
  if (!Array.isArray(e.warnings)) return false;
  if (!Array.isArray(e.pendingRecommendations)) return false;
  return true;
}

export function parseInternalOperatorRealtimeWsMessage(
  raw: string
): InternalOperatorRealtimeEnvelopeV1 | null {
  try {
    const msg = JSON.parse(raw) as {
      type?: string;
      envelope?: InternalOperatorRealtimeEnvelopeV1;
    };
    if (
      msg.type === INTERNAL_OPERATOR_REALTIME_KIND &&
      msg.envelope?.kind === INTERNAL_OPERATOR_REALTIME_KIND &&
      isValidInternalOperatorEnvelopeV1(msg.envelope)
    ) {
      return msg.envelope;
    }
  } catch {
    /* ignore */
  }
  return null;
}
